const landingPath = (() => {
  const base = String(process.env.BASE_URL || '/').replace(/\/+$/, '')
  let path = window.location.pathname || '/'
  if (base && path.startsWith(base)) path = path.slice(base.length) || '/'
  if (!path.startsWith('/')) path = `/${path}`
  return path
})()

const isLobbyLanding = landingPath === '/'
let played = false

export function shouldPlayBootLoader () {
  if (played) return false
  played = true
  return isLobbyLanding
}
